import { Component, Vue } from 'vue-property-decorator';
import IAdminService from '@/services/http/interfaces/IAdminService';
import { TenantDetailsApi, CloudOrganizationSummary } from '@/common/models';
import TenantDetailsStore from '@/store/modules/TenantDetailsStoreModule';
import { TenantDetailsNav, TenantDetailsHeader, TenantDetailsEditTenant } from '@/components/tenantDetails';
import { TenantDetailsStoreModule, TenantsStoreModule, AppStoreModule, CloudOrganizationsStoreModule } from '@/store';
import { TenantDetailsForm } from '@/common/viewModels/tenantDetails';
import TenantsStore from '@/store/modules/TenantsStoreModule';
import AppStore from '@/store/modules/AppStoreModule';
import CloudOrganizationsStore from '@/store/modules/CloudOrganizationsStoreModule';
import { ItemViewModel } from '@/common/viewModels';

@Component({
  components: {
    TenantDetailsNav,
    TenantDetailsHeader,
    TenantDetailsEditTenant,
  },
})
export default class TenantDetails extends Vue {

  tenants$: TenantsStore = TenantsStoreModule;
  cloudOrganizations$: CloudOrganizationsStore = CloudOrganizationsStoreModule;
  tenantDetails$: TenantDetailsStore = TenantDetailsStoreModule;
  app$: AppStore = AppStoreModule;

  private adminService?: IAdminService;

  get tenantId() {
    return this.$route.params.tenantId;
  }

  get tenantDetails(): TenantDetailsApi | null {
    return this.tenantDetails$.tenantDetails;
  }

  get salesChannels(): ItemViewModel[] {
    return this.tenantDetails$.salesChannels;
  }

  get tenantPartners(): ItemViewModel[] | null {
    return this.tenantDetails$.tenantPartners;
  }

  get cloudOrganization(): CloudOrganizationSummary | undefined | null {
    return this.cloudOrganizations$.currentCloudOrganization;
  }

  get form(): TenantDetailsForm {
    return this.tenantDetails$.form;
  }

  get isLoading(): boolean {
    return this.app$.isLoading;
  }

  mounted() {
    this.initServices();

    Promise.all([
      this.tenants$.getTenants(this.adminService!),
      this.tenantDetails$.getTenantDetails({ adminService: this.adminService!, tenantId: this.tenantId }),
      this.tenantDetails$.getTenantPartners({ adminService: this.adminService!, tenantId: this.tenantId }),
      this.cloudOrganizations$.getCloudOrganizations(this.adminService!),
    ]);
  }

  initServices(): void {
    this.adminService = this.$factory.createAdminService();
  }

  goBack(): void {
    this.$router.push({
      name: 'Tenants',
    });
  }

  manageUsersClicked(): void {
    this.$router.push({
      name: 'Users',
      params: {
        tenantId: this.$route.params.tenantId,
      },
    });
  }

  tenantFormInputChange(fieldName: string, value: any) {
    if (fieldName !== 'mpnId') {
      this.tenantDetails$.tenantFormInputChange({ fieldName, value });
    }
  }

  async onStatusActiveClick(): Promise<void> {
    await this.tenantDetails$.activateCloudOrganization(this.adminService!);
    await this.cloudOrganizations$.getCloudOrganizations(this.adminService!);
    (this.$refs.tenantDetailsEditTenant as TenantDetailsEditTenant).hideStatusActiveConfirmationModal();
  }

  async navAction(actionType: string) {
    const actionMap: any = {
      close: () => () => this.goBack(),
      edit: () => this.tenantDetails$.requestEdit(this.adminService!),
    };

    const isSuccessful: boolean = await actionMap[actionType]();

    if (isSuccessful) {
      this.goBack();
    }
  }

  async onAddMicrosoftPartnerClick(): Promise<void> {
    await this.tenantDetails$.verifyMicrosoftPartnerDetails(this.adminService!);
  }

  async onEditMicrosoftPartnerClick(): Promise<void> {
    this.tenantDetails$.editMicrosoftPartner();
  }

  async onRemoveMicrosoftPartnerClick(): Promise<void> {
    await this.tenantDetails$.removeMicrosoftPartner();
  }

  async onMicrosoftPartnerInput(mpnId: string): Promise<void> {
    await this.tenantDetails$.microsoftPartnerInput(mpnId);
  }
}
